<template>
  <div class="lang-page">
    <div class="lang-nav van-nav-bar">
      <div class="van-nav-bar__content">
        <div class="van-nav-bar__left" @click="back()">
          <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
        </div>
        <div class="van-nav-bar__title van-ellipsis">{{ $t('setting.language') || 'Language Selection' }}</div>
      </div>
    </div>

    <div class="lang-body">
      <div class="lang-card">
        <div
          v-for="(item, idx) in langList"
          :key="idx"
          class="lang-item"
          :class="{ 'border-bottom': idx !== langList.length - 1 }"
          @click="changeLang(item.code)"
        >
          <span class="lang-name">{{ item.name }}</span>
          <span v-if="currentLang === item.code" class="check-icon">✓</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "Language",
  data() {
    return {
      currentLang: localStorage.getItem("lang") || this.$i18n.locale || "hk",
      source: '',
      langList: [
        { code: 'hk', name: '繁體中文' },
        { code: 'en', name: 'English' },
        { code: 'tr', name: 'Türkçe' }
      ]
    };
  },
  mounted() {
    this.source = this.$route.params.type;
  },
  methods: {
    back() {
      return window.history.back();
    },
    replaceLang(lang) {
      this.$http({
        method: "get",
        url: "replaceLang",
        data: { lang }
      }).then(() => {});
    },
    changeLang(lang) {
      Toast.loading({ duration: 200 });
      this.currentLang = lang;
      this.$i18n.locale = lang;
      this.replaceLang(lang);
      localStorage.setItem("lang", lang);

      setTimeout(() => {
        if (this.source === 'setting') {
          this.$router.push({ path: '/' });
        } else {
          this.$router.go(-1);
        }
      }, 200);
    }
  }
};
</script>

<style scoped>
.lang-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f7;
  display: flex;
  flex-direction: column;
}

.lang-nav {
  position: relative;
  height: 100px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% auto;
}

::v-deep .lang-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .lang-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px !important;
}

::v-deep .lang-nav .van-icon-arrow-left {
  color: #ffffff !important;
  font-size: 40px !important;
}

.lang-body {
  padding: 30px 24px;
}

.lang-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.lang-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 30px;
  font-size: 30px;
  color: #333333;
  cursor: pointer;
}

.border-bottom {
  border-bottom: 1px solid #f0f0f0;
}

.lang-name {
  font-size: 30px;
  color: #333333;
}

.check-icon {
  color: #f560cd;
  font-size: 32px;
  font-weight: 700;
}
</style>
